import { render, staticRenderFns } from "./visitor.vue?vue&type=template&id=3560d9c8&scoped=true&"
import script from "./visitor.vue?vue&type=script&lang=js&"
export * from "./visitor.vue?vue&type=script&lang=js&"
import style0 from "./visitor.vue?vue&type=style&index=0&id=3560d9c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560d9c8",
  null
  
)

export default component.exports